import { ThumbnailCardCombinedProps } from './types';

const usePresenter = (props: ThumbnailCardCombinedProps): ThumbnailCardCombinedProps => {
  return props;
};

export default usePresenter;
